import { Flex } from "antd";
import { runInAction } from "mobx";
import { observer } from "mobx-react-lite";
import React, { useEffect, useState } from "react";
import { MetaField, StepFieldType, StepMetaTag, useMetaFields } from "..";
import ScheduleMetaInput from "./ScheduleMetaInput";

export const ScheduleMetaFormItems = observer(
  (props: {
    value: StepFieldType[];
    setValue: (value: StepFieldType[]) => void;
  }) => {
    const [reload, setReload] = useState<number>(0);
    const { metaFields, results, setResults, getTagValue, stepFieldHasValue } =
      useMetaFields(props.value);

    useEffect(() => {
      if (
        props.setValue === undefined ||
        typeof props.setValue !== "function" ||
        results === undefined
      ) {
        return;
      }
      props.setValue(results);
    }, [reload]);

    //If props.setValue is undefined the component is only for display
    if (props.setValue === undefined) {
      return (
        <Flex vertical gap="middle">
          {props.value.filter(stepFieldHasValue).map((stepfield, index) => (
            <StepMetaTag
              stepfield={stepfield}
              key={index}
              getTagValue={getTagValue}
            />
          ))}
        </Flex>
      );
    }

    if (props.value === undefined && metaFields !== undefined) {
      return (
        <>
          {metaFields.map((metaField: MetaField) => {
            return (
              <ScheduleMetaInput
                onChange={(value) => {
                  runInAction(() => {
                    setResults((prev) => {
                      //find the index of the metafield in the results array
                      const index = prev.findIndex(
                        (field) => field.metafield.label === metaField.label
                      );

                      const newResults = [...prev];
                      newResults[index] = {
                        value,
                        metafield: metaField,
                      };

                      return newResults;
                    });

                    setReload((prev) => prev + 1);
                  });
                }}
                key={metaField.label}
                field={{
                  metafield: metaField,
                  value: undefined,
                }}
              />
            );
          })}
        </>
      );
    }

    if (props.value === undefined) {
      return <></>;
    }

    // If the value is already set, display the input fields
    return (
      <>
        {props.value.map((field, index) => (
          <ScheduleMetaInput
            onChange={(value) => {
              runInAction(() => {
                setResults((prev) => {
                  const newResults = [...prev];
                  newResults[index] = {
                    value,
                    metafield: field.metafield,
                  };
                  return newResults;
                });

                setReload((prev) => prev + 1);
              });
            }}
            key={index}
            field={field}
          />
        ))}
      </>
    );
  }
);
